// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"edc536e4","453":"b6dabc91","455":"8e07e52f"}[chunkId] + ".chunk.js";
};